export default "__VITE_ASSET__C44$0W6T__"